import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-add-auction',
  templateUrl: './add-auction.component.html',
  styleUrls: ['./add-auction.component.scss']
})
export class AddAuctionComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  Auction: FormGroup;
  submitted: boolean = false;
  isLoading: boolean;
  users = [];
  subtype = [];
  district = [];
  taluka = [];
  village = [];
  Type: any;
  Data:any[]=[];
  UserID: any;
  id: any;
  myValue: any;
  isShowDistrict: boolean = true;
  isShowTaluka: boolean = false;
  isShowVillage: boolean = false;
  StartDate: Date = new Date();
  newdate: string;
  updatedata: any;
  Update:any[]=[]
  startDate: any;
  UsersubscriptionMainID: any;
  originalAuctionValues: any;
  updateButtonDisabled: boolean = true;

  constructor(private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router,
    private route: ActivatedRoute,private datepipe: DatePipe) { 
      let a = this.router.getCurrentNavigation().extras
      if(a){
        if(a.state){
          this.UserID = a.state.UserId
          this.Type = a.state.isEdit
          this.UsersubscriptionMainID = a.state.id
          localStorage.setItem('UserID',this.UserID)
          localStorage.setItem('UsersubscriptionMainID',this.UsersubscriptionMainID)
          localStorage.setItem('Type',this.Type)
         
        }
      }
      if(localStorage.getItem('UserId')){
        this.UserID = localStorage.getItem('UserId')
      }
      if(localStorage.getItem('UsersubscriptionMainID')){
        this.UsersubscriptionMainID = localStorage.getItem('UsersubscriptionMainID')
      }
      if(localStorage.getItem('type')){
        this.UserID = localStorage.getItem('type')
      }
      console.log('UserId',this.UserID)
      console.log('type',this.Type)
      if(this.Type !== true){
        this.breadCrumbItems = [
          { label: "Auction alert List", path: "/users/auctionAlert" },
          { label: "Add Auction Alert", path: "/", active: true },
        ];
      }else{
        this.breadCrumbItems = [
          { label: "Auction alert List", path: "/users/auctionAlert" },
          { label: "Update Auction Alert", path: "/", active: true },
        ];
      }
    }

  ngOnInit() {
    this.newdate = new Date().toISOString().substr(0, 10);
    this.Auction = this.fb.group({
      UserID: new FormControl(this.UserID),
      Service_Sub_Type_ID: new FormControl(null, [Validators.required]),
      SubType_Name: new FormControl(null),
      DistrictID: new FormControl(null, Validators.required),
      DistrictName: new FormControl(null),
      TalukaName:new FormControl(null),
      VillageName:new FormControl(null),
      TalukaID: new FormControl(null),
      VillageID: new FormControl(null),
      startDate: new FormControl(null, [Validators.required, Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      endDate: new FormControl(null, [Validators.required, Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      aucfor: new FormControl(null, Validators.required),
      dist: new FormControl(null, Validators.required),
      tal: new FormControl(null),
      vill: new FormControl(null),
      UsersubscriptionMainID: new FormControl(null)
    },
    { validators: this.startDateBeforeEndDateValidator }
    );
    // this.Data.push(this.Auction.value)


    console.log('Data',this.Data)
    if(this.Type === true){
      this.isLoading = true
      this.gs.editAuction(this.UsersubscriptionMainID).subscribe((res:any)=>{
        this.setData(res)
        this.Auction.controls.aucfor.disable()
        this.isLoading = false;
      })
      
     }
    this.startDate = this.Auction.controls.startDate.value
    this.isLoading = true;
    this.gs.getSubType().subscribe(
      (Response: any) => {
        this.subtype = Response.data;
        this.isLoading = false
        // console.log("line==77", this.subtype);
      },
      (error) => {
        this.isLoading = false;
        //Error callback
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.isLoading= true;
    this.gs.UserDistrictWise(this.UserID).subscribe(
      (Response: any) => {
        this.district = Response.data;
        this.isLoading = false;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  isFormUnchanged(): boolean {
    // Check if the current form values are the same as the original values
    return this.Auction.value === this.originalAuctionValues;
  }
  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('startDate').value;
    const endDate = control.get('endDate').value;

    if (startDate && endDate && startDate > endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }
  setData(data){
    console.log('data',data);
    
    this.updatedata = data.data
   
    this.Update.push(this.updatedata)
    console.log('Update data',this.updatedata)
    console.log('Updaye',this.Update)
    this.Auction.controls.UsersubscriptionMainID.setValue(this.updatedata.UserSubscriptionMainID)
    this.Auction.controls.Service_Sub_Type_ID.setValue(this.updatedata.Service_Sub_Type_ID)
    this.Auction.controls.aucfor.setValue(this.updatedata.SubType_Name)
    this.Auction.controls.dist.setValue(this.updatedata.DistrictName)
    this.Auction.controls.DistrictID.setValue(this.updatedata.DistrictID)
    this.Auction.controls.DistrictName.setValue(this.updatedata.DistrictName)
    this.Auction.controls.VillageName.setValue(this.updatedata.VillageName)

    if(this.updatedata.TalukaID && !this.updatedata.VillageID){
      this.Auction.controls.tal.setValue(this.updatedata.talukaName)
      this.Auction.controls.TalukaID.setValue(this.updatedata.TalukaID)
      this.Auction.controls.TalukaName.setValue(this.updatedata.talukaName);
    }
    if(this.updatedata.VillageID){
      this.Auction.controls.tal.setValue(this.updatedata.talukaName)
      this.Auction.controls.TalukaID.setValue(this.updatedata.TalukaID)
      this.Auction.controls.TalukaName.setValue(this.updatedata.talukaName)
      this.Auction.controls.vill.setValue(this.updatedata.VillageName)
      this.Auction.controls.VillageID.setValue(this.updatedata.VillageID)
      this.Auction.controls.VillageName.setValue(this.updatedata.VillageName);
      this.Auction.controls.vill.updateValueAndValidity();
    }
    console.log('fromdta',this.Auction.value);
   
    this.Auction.controls.startDate.setValue(this.datepipe.transform(this.updatedata.startDate, 'yyyy-MM-dd'))
    this.Auction.controls.endDate.setValue(this.datepipe.transform(this.updatedata.endDate, 'yyyy-MM-dd'))
    this.onSubtype(this.updatedata)
    this.onDistrict(this.updatedata)
    this.onTaluka(this.updatedata)
    this.onVillage(this.updatedata)
    // this.dublicateDat()
    console.log('fromdta',this.Auction.value);
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  // dublicateDat(){
  //   this.originalAuctionValues = { ...this.Auction.value };
  //   console.log('originalAuctionValues', this.originalAuctionValues)
  //   this.Auction.valueChanges.subscribe(() => {
  //     this.updateButtonDisabled = this.isFormUnchanged();
  //   });
  //   console.log('updateButtonDisabled', this.updateButtonDisabled)
  //   console.log('AUction Vlaues',this.Auction.value)
  // }
  onSubtype(e) {
    if(e === undefined){
      this.Auction.controls.dist.setValue(null)
      this.Auction.controls.tal.setValue(null)
      this.Auction.controls.vill.setValue(null)
      this.district = [];
      this.village = [];
      this.taluka = [];
      if(this.Type !== true){
        this.Auction.controls.aucfor.setValue(null)
      }else{
        this.Auction.controls.aucfor.setValue(this.updatedata.SubType_Name)
      }
    }
    this.Auction.controls.SubType_Name.setValue(e.SubType_Name)
    this.Auction.controls.Service_Sub_Type_ID.setValue(e.Service_Sub_Type_ID)
    if(e.Service_Sub_Type_ID == 21){
      this.isShowDistrict = true;
      this.isShowTaluka = false;
      this.isShowVillage = false;
     
    }
   else if(e.Service_Sub_Type_ID == 22){
    this.isShowDistrict = true;
    this.isShowTaluka = true;
    this.isShowVillage = false;
  
    }
   else if(e.Service_Sub_Type_ID == 23){
    this.isShowDistrict = true;
    this.isShowTaluka = true;
    this.isShowVillage = true;
 
    }
  }
  onDistrict(e) {
    this.isLoading= true;
    if(e === undefined){
      this.Auction.controls.tal.setValue(null)
      this.Auction.controls.vill.setValue(null)
      this.isLoading= false;
      this.taluka = [];
      this.village = [];
    }
    if(e.Districtid){
      this.Auction.controls.DistrictName.setValue(e.districtname)
      this.Auction.controls.DistrictID.setValue(e.Districtid)
      this.Auction.controls.tal.setValue(null)
      this.Auction.controls.vill.setValue(null)
    }
    if(e.DistrictID){
      this.Auction.controls.DistrictName.setValue(e.DistrictName)
      this.Auction.controls.DistrictID.setValue(e.DistrictID)
    }
    // this.Auction.controls.tal.setValue(null)
    // this.Auction.controls.vill.setValue(null)
    this.gs.getTaluka(this.Auction.controls.DistrictID.value).subscribe(
      (Response) => {
        this.taluka = Response.data;
        this.isLoading= false;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.originalAuctionValues = { ...this.Auction.value };
    console.log('originalAuctionValues', this.originalAuctionValues)
    this.Auction.valueChanges.subscribe(() => {
      this.updateButtonDisabled = this.isFormUnchanged();
    });
    console.log('updateButtonDisabled', this.updateButtonDisabled)
  }
  onTaluka(e) {
    this.isLoading = true;
    if(e === undefined){
      this.Auction.controls.vill.setValue(null)
      this.isLoading = false;
      this.village =[]
    }
    if(e.TalukaName){
      this.Auction.controls.TalukaID.setValue(e.TalukaID)
      this.Auction.controls.TalukaName.setValue(e.TalukaName)
      this.Auction.controls.vill.setValue(null)
    }
    if(e.talukaName){
      this.Auction.controls.TalukaID.setValue(e.TalukaID)
      this.Auction.controls.TalukaName.setValue(e.talukaName)
    }
    this.Auction.controls.VillageID.setValue(null)
    
    this.gs.getVillage(this.Auction.controls.TalukaID.value).subscribe(
      (Response: any) => {
        this.village = Response.data;
        this.isLoading = false;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  onVillage(e) {
    if(e.VillageName){
      this.Auction.controls.VillageID.setValue(e.VillageID)
      this.Auction.controls.VillageName.setValue(e.VillageName)
    }
    // if(e.villageName){
    //   this.Auction.controls.VillageID.setValue(e.VillageID)
    //   this.Auction.controls.VillageName.setValue(e.villageName)
    // }
  }
  datechange() {
    this.Auction.controls.endDate.setValue(null)
    var date = new Date(this.Auction.controls.startDate.value);
    this.Auction.controls.endDate.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
  add_years(dt,n)
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
  get f() {
    return this.Auction.controls;
  }
  onSubmit(){
    this.UsersubscriptionMainID = this.Auction.controls.UsersubscriptionMainID.value
   
    this.submitted = true;
    this.isLoading = true;
    if (this.Auction.valid) {
      const startdatevalue = this.Auction.value.startDate
      this.datepipe.transform(this.StartDate, 'yyyy-MM-dd')
      if(startdatevalue < this.StartDate){
        this.Auction.controls.startDate.setErrors({ 'pastDate': true })
      }

      delete this.Auction.value.aucfor;
      delete this.Auction.value.dist;
      delete this.Auction.value.tal;
      delete this.Auction.value.vill;

      if(this.Type !== true){
        delete this.Auction.value.UsersubscriptionMainID
        this.gs
          .AddAuction(this.Auction.value.UserID, this.Auction.value)
          .subscribe(
            (data) => {
              this.isLoading = false;
  
              if (data.status === 200) {
                this.submitted = false;
                Swal.fire({
                  title: "Auction Uploaded",
                  text: data.message,
                  type: "success",
                }).then(() => {
                  this.submitted = false;
                  // this.reFresh.emit();
                  this.router.navigate(["/users/auctionAlert"]);
                });
              } else {
                Swal.fire({
                  text: data.Message,
                  type: "info",
                });
                this.router.navigate(["/users/auctionAlert"]);
              }
            },
            (error) => {
              //Error callback
              this.isLoading = false;
              Swal.fire({
                title: error.status,
                text: "Internal Server Error",
                type: "error",
              });
              //throw error;   //You can also throw the error to a global error handler
            }
          );
      }else{
        console.log('Updated Value',this.Auction.value)
        this.gs.UpdateAuction(this.UsersubscriptionMainID,this.Auction.value).subscribe((res:any)=>{
          this.isLoading = false;
          if(res.status === 400){
            Swal.fire({
              text: res.Message,
              type: "info",
              timer: 1500
            }).then(()=>{
              this.submitted = false;
              // this.reFresh.emit();
              this.router.navigate(['users/auctionAlert']);
            })
          }
          if(res.status === 200){
            Swal.fire({
              title: 'User Auction Updated',
              text: res.message,
              type: 'success',
            }).then(() => { 
              this.submitted = false;
              // this.reFresh.emit();
              this.router.navigate(['users/auctionAlert']);
            });
          }
        })
      }
    }else{
      return this.isLoading = false
    }
  }

}
